import { Property } from './interfaces';

export const nomTecnologiaSalud: Property = {
  title: 'Nombre de Tecnología de Salud',
  type: 'string',
};
